import React from 'react';
import AltContainer from 'alt-container';

import LibraryActions from 'actions/library/LibraryActions';
import LibraryCreateActions from 'actions/library/LibraryCreateActions';
import AuthStore from 'stores/AuthStore';
import LibraryCreateFormStore from 'stores/library/LibraryCreateFormStore';
import LibraryStore from 'stores/library/LibraryStore';

import LibraryBrowseTab from './LibraryBrowseTab';

export default class LibraryBrowseTabContainer extends React.Component {
  static displayName = 'LibraryBrowseTabContainer';

  componentDidMount() {
    setTimeout(() => {
      LibraryActions.getLibraries();
      LibraryActions.getShareAccessibleDepartments();
      LibraryActions.getShareAccessibleTeams();
    }, 0);
  }

  render() {
    return (
      <AltContainer
        actions={{LibraryActions, LibraryCreateActions}}
        stores={{AuthStore, LibraryCreateFormStore, LibraryStore}}>
        <LibraryBrowseTab {...this.props} />
      </AltContainer>
    );
  }
}
